// src/pages/TermsPage.js
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';

export default function TermsPage() {
  return (
    <div className="page">
      <Navbar />
      <div className="container" style={{ paddingTop: 32, paddingBottom: 60 }}>
        <h1 style={{ fontSize: '1.5rem', marginBottom: 4 }}>Terms of Service</h1>
        <p style={{ color: 'var(--muted)', fontSize: '0.82rem', marginBottom: 24 }}>Last updated: March 2026</p>

        <div className="card" style={{ fontSize: '0.84rem', lineHeight: 1.7, color: 'var(--text)' }}>
          <h3 style={{ fontSize: '0.95rem', marginBottom: 8 }}>1. Not Legal Advice</h3>
          <p style={{ marginBottom: 16, color: 'var(--muted)' }}>
            TuttoClaro is <strong>not a law firm</strong> and does not provide legal advice. Agreements created
            on this platform are informal records between parties. They do not constitute legally binding
            contracts unless applicable law in your jurisdiction treats them as such. For legal matters,
            consult a licensed attorney.
          </p>

          <h3 style={{ fontSize: '0.95rem', marginBottom: 8 }}>2. User Responsibility</h3>
          <p style={{ marginBottom: 16, color: 'var(--muted)' }}>
            You are solely responsible for the content of agreements you create. You agree not to use TuttoClaro
            for any illegal, fraudulent, or harmful purposes. You represent that you have the authority to enter
            into any agreement you create or confirm on this platform.
          </p>

          <h3 style={{ fontSize: '0.95rem', marginBottom: 8 }}>3. Accounts</h3>
          <p style={{ marginBottom: 16, color: 'var(--muted)' }}>
            You may create an account using email/password or Google authentication. You are responsible for
            maintaining the security of your account credentials. We reserve the right to suspend or terminate
            accounts that violate these terms.
          </p>

          <h3 style={{ fontSize: '0.95rem', marginBottom: 8 }}>4. Agreements & Data</h3>
          <p style={{ marginBottom: 16, color: 'var(--muted)' }}>
            Agreements are stored in Firebase Cloud Firestore. Evidence files (photos, PDFs) are stored in
            Firebase Cloud Storage. We retain your data as long as your account is active. You may request
            deletion of your data by contacting us.
          </p>

          <h3 style={{ fontSize: '0.95rem', marginBottom: 8 }}>5. Premium & Payments</h3>
          <p style={{ marginBottom: 16, color: 'var(--muted)' }}>
            Premium and Business subscriptions are billed monthly via Stripe. You may cancel at any time.
            Refunds are handled on a case-by-case basis. Feature availability may change with notice.
          </p>

          <h3 style={{ fontSize: '0.95rem', marginBottom: 8 }}>6. Limitation of Liability</h3>
          <p style={{ marginBottom: 16, color: 'var(--muted)' }}>
            TuttoClaro is provided "as is" without warranties of any kind. We are not liable for any disputes
            between parties, lost data, or damages arising from use of this platform. Our total liability
            is limited to the amount you paid us in the 12 months preceding any claim.
          </p>

          <h3 style={{ fontSize: '0.95rem', marginBottom: 8 }}>7. Changes</h3>
          <p style={{ color: 'var(--muted)' }}>
            We may update these terms at any time. Continued use of TuttoClaro after changes constitutes
            acceptance of the new terms.
          </p>
        </div>

        <p style={{ textAlign: 'center', fontSize: '0.78rem', color: 'var(--muted)', marginTop: 16 }}>
          Questions? Contact us at support@tuttoclaro.com
        </p>
        <Link to="/" className="btn btn-secondary" style={{ marginTop: 8 }}>Back to Home</Link>
      </div>
    </div>
  );
}
